import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

(function (Drupal, once) {

  Drupal.behaviors.bendrejatSwiper = {

    attach(context) {

      // Views slider.

      once(
        'bendrejat-swiper',
        '.views-slider .swiper',
        context
      ).forEach((container) => {

        const wrapper = container.closest('.views-slider-container');
        const caption = wrapper.querySelector('.views-slider__caption-inner');

        const updateCaption = (swiper) => {

          const activeSlide = swiper.slides[swiper.activeIndex];
          const source = activeSlide.querySelector(
            '.field--name-field-image-caption'
          );
          const image = activeSlide.querySelector('img');

          caption.innerHTML = source ? source.innerHTML : '';

          if (!image) {
            caption.style.width = '';
            return;
          }

          const updateWidth = () => {
            const width = image.getBoundingClientRect().width;

            if (width > 0) {
              caption.style.width = `${width}px`;
            }
          };

          if (image.complete && image.naturalWidth > 0) {
            updateWidth();
          } else {
            image.addEventListener('load', updateWidth, { once: true });
          }

        };

        const swiper = new Swiper(container, {

          modules: [Navigation],

          slidesPerView: 1,

          preventClicks: false,
          preventClicksPropagation: false,

          navigation: {
            prevEl: wrapper.querySelector('.views-slider__prev'),
            nextEl: wrapper.querySelector('.views-slider__next'),
          },

          on: {
            init: updateCaption,
            slideChange: updateCaption,
            resize: updateCaption,
          },

          breakpoints: {
            1024: {
              slidesPerView: 'auto',
            },
          }

        });

        if (swiper.slides.length === 1) {
          wrapper.classList.add('views-slider--single');
        }

      });

    }

  };

})(Drupal, once);